module.exports = __webpack_public_path__ + "img/invoices_blue.c0f88efa.svg";